import { PencilIcon } from '@grupoboticario/flora-react-icons';
import { CardInfo } from '../../sharedStyles';

import {
  CardInfoTitleSummary,
  EditButton,
  ExtraTitle,
  CardInfoWhatIs,
  CardInfoWhatIsnt,
  CardInfoWhatWrapper,
} from '../styles';

interface ICardSummary {
  editStep?: any;
  stateClaim: any;
}

export const Card01 = ({ editStep, stateClaim }: ICardSummary): JSX.Element => {
  return (
    <CardInfo>
      <CardInfoTitleSummary>
        Tipo de sinistro
        {editStep && (
          <EditButton
            size="small"
            has="iconLeft"
            icon={<PencilIcon />}
            onClick={() => editStep(1)}
          >
            Editar
          </EditButton>
        )}
      </CardInfoTitleSummary>
      <ExtraTitle>{stateClaim.step.step1?.tipos?.data?.name}</ExtraTitle>
      {stateClaim.step.step1?.tipos?.data?.help.length === 2 && (
        <CardInfoWhatWrapper>
          <CardInfoWhatIs>
            <div className="title">O que cobre?</div>
            {stateClaim.step.step1?.tipos?.data?.help[0]
              .split('\n')
              .map((paragraph: string) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
          </CardInfoWhatIs>
          <CardInfoWhatIsnt>
            <div className="title">O que não cobre?</div>
            {stateClaim.step.step1?.tipos?.data?.help[1]
              .split('\n')
              .map((paragraph: string) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
          </CardInfoWhatIsnt>
        </CardInfoWhatWrapper>
      )}
    </CardInfo>
  );
};
